// extracted by mini-css-extract-plugin
export default {"course__swiper":"course-swiper_course__swiper__07jni","course__wrapper":"course-swiper_course__wrapper__BuoGN"};